<div class="detailed-checkbox-container">
  <mat-checkbox
    [id]="id"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [tabindex]="templateOptions.tabindex || 0"
    [color]="templateOptions.color"
    class="detailed-checkbox"
  >
    <div class="checkbox-content">
      <div class="icon-content" *ngIf="templateOptions.icon">
        <mat-icon class="checkbox-icon">{{ templateOptions.icon }}</mat-icon>
      </div>
      <div class="text-content">
        <div class="main-label" *ngIf="templateOptions.mainLabel">
          {{ templateOptions.mainLabel }}
        </div>
        <div class="secondary-text" *ngIf="templateOptions.secondaryText">
          {{ templateOptions.secondaryText }}
        </div>
      </div>
    </div>
  </mat-checkbox>
</div>
